export const DRAWER_TRANSITION_DURATION = 500;
